const StorageKeys = {
    ACCESS_TOKEN: 'access_token',
    USER: 'user',
};

export default StorageKeys;
